/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "5fc313476f494f757456ffdb66cfa34f2be530e3";
